import AstroStaticPage from "@/common/components/AstroStaticPage";
import React from "react";
import { Data } from "./data";

const Yoga = () => {
  return <AstroStaticPage data={Data} />;
};

export default Yoga;
